<div class="pedido-card"
     role="button"
     tabindex="0"
     (click)="onCardClick()"
     (keydown.enter)="onCardClick()">

  <!-- Header colorido -->
  <div class="pedido-card-header"
       [style.background]="getBackgroundEstado(pedido.estadoDePedido)">
    <div class="header-left">
      <i [class]="getIconeEstado(pedido.estadoDePedido)" aria-hidden="true"></i>
      <span class="estado-label">{{ getEstadoLabel(pedido.estadoDePedido) }}</span>
    </div>
    <!-- Data e hora estatica do pedido (sempre visivel) -->
    <span class="hora-label">{{ formatarDataHora(pedido.emissao) }}</span>
  </div>

  <!-- Body -->
  <div class="pedido-card-body">
    <div class="pedido-numero-row">
      <span class="pedido-numero">
        {{ texts?.labels?.pedido }} #{{ pedido.codigoDePedido }}
      </span>
      <!-- Badge de origem do pedido (Mini Shop / Cardapio Digital) -->
      <span class="origem-badge" *ngIf="getOrigemPedido()">
        <i [class]="getOrigemIcone()" aria-hidden="true"></i>
        {{ getOrigemLabel() }}
      </span>

      <!-- Tempo decorrido desde a emissao -->
      <span class="timer-inline" *ngIf="isEstadoAtivo" [class.timer-critico]="timerCritico">
        <i class="pi pi-clock" aria-hidden="true"></i>
        {{ tempoDecorrido }}
      </span>
    </div>

    <!-- Linha das classificacoes do pedido; some inteira se nao houver tag. -->
    <div class="pedido-tags-row" *ngIf="temTipoEntrega() || statusFaturamento">
      <!-- Badge de tipo de entrega (Retirada / Delivery) -->
      <span class="tipo-entrega-badge"
            *ngIf="temTipoEntrega()"
            [class]="'tipo-entrega-badge ' + getTipoEntregaClasse()">
        <i [class]="getTipoEntregaIcone()" aria-hidden="true"></i>
        {{ getTipoEntregaLabel() }}
      </span>
      <!-- Situacao de faturamento (regra em `statusFaturamento`) -->
      <span class="faturado-badge"
            *ngIf="statusFaturamento as situacao"
            [class.parcial]="situacao === 'parcial'">
        <i [class]="situacao === 'parcial' ? 'pi pi-hourglass' : 'pi pi-check-circle'"
           aria-hidden="true"></i>
        {{ situacao === 'parcial' ? texts?.labels?.faturado_parcial : texts?.labels?.faturado }}
      </span>
    </div>

    <div class="pedido-info">
      <div class="info-row">
        <i class="pi pi-user" aria-hidden="true"></i>
        <span>{{ pedido.nomeCliente || '-' }}</span>
      </div>

      <div class="info-row" *ngIf="pedido.telefone">
        <i class="pi pi-phone" aria-hidden="true"></i>
        <span>{{ pedido.telefone }}</span>
      </div>

      <div class="info-row" *ngIf="pedido.numeroMesa != null">
        <i class="pi pi-th-large" aria-hidden="true"></i>
        <span>{{ texts?.labels?.mesa }}: {{ pedido.numeroMesa }}</span>
      </div>

      <div class="info-row" *ngIf="pedido.numeroComanda != null">
        <i class="pi pi-tag" aria-hidden="true"></i>
        <span>{{ texts?.labels?.comanda }}: {{ pedido.numeroComanda }}</span>
      </div>

      <div class="info-row" *ngIf="ehDelivery() && pedido.enderecoDeEntrega">
        <i class="pi pi-map-marker" aria-hidden="true"></i>
        <span [title]="pedido.enderecoDeEntrega">{{ pedido.enderecoDeEntrega }}</span>
      </div>

      <div class="info-row" *ngIf="ehDelivery()">
        <i class="pi pi-send" aria-hidden="true"></i>
        <span>{{ texts?.labels?.frete }}: {{ (pedido.valorFrete || 0) | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}</span>
      </div>

      <div class="info-row valor-row">
        <i class="pi pi-money-bill" aria-hidden="true"></i>
        <span class="valor-total">{{ pedido.valorTotal | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}</span>
      </div>

      <div class="info-row observacao-row" *ngIf="getObservacaoFormatada()">
        <i class="pi pi-comment" aria-hidden="true"></i>
        <span class="observacao-text" [title]="getObservacaoFormatada()">{{ getObservacaoFormatada() }}</span>
      </div>

      <!-- Itens do pedido com variantes / modificadores / observação -->
      <div class="pedido-itens" [class.pedido-encerrado]="pedidoEncerrado()" *ngIf="itensDoPedido.length">
        <div class="pedido-item-linha"
             *ngFor="let item of itensDoPedido"
             [class.item-faturado]="linhaFaturada(item)"
             [class.item-cancelado]="linhaCancelada(item)">
          <div class="pedido-item-nome">
            <i class="pi pi-box" aria-hidden="true"></i>
            <span>{{ item.quantidade }}× {{ nomeDoItem(item) }}</span>
          </div>
          <span class="pedido-item-detalhe" *ngIf="item.variantesDePreco && item.variantesDePreco.length > 0">
            <i class="pi pi-tag" aria-hidden="true"></i>
            {{ texts?.labels?.variantes || 'Variantes' }}: {{ formatarVariantes(item.variantesDePreco, item.quantidade) }}
          </span>
          <span class="pedido-item-detalhe" *ngIf="item.modificadores && item.modificadores.length > 0">
            <i class="pi pi-plus-circle" aria-hidden="true"></i>
            {{ texts?.labels?.modificadores || 'Modificadores' }}: {{ formatarModificadores(item.modificadores, item.quantidade) }}
          </span>
          <span class="pedido-item-detalhe" *ngIf="item.observacao">
            <i class="pi pi-comment" aria-hidden="true"></i>
            {{ item.observacao }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer com botoes -->
  <div class="pedido-card-footer">
    <!-- Linha de botoes de estado (avanco + faturar + entregar + finalizar + cancelar) -->
    <div class="footer-estado-row" *ngIf="temBotaoAvanco() || temBotaoFaturar() || temBotaoEntregar() || temBotaoFinalizar() || temBotaoCancelar()">
      <button pButton
              type="button"
              *ngIf="temBotaoAvanco()"
              [icon]="getIconeAvanco()"
              [pTooltip]="getLabelAvanco()"
              [attr.aria-label]="getLabelAvanco()"
              tooltipPosition="top"
              class="p-button-outlined p-button-rounded p-button-icon-only botao-avancar-estado"
              [style.--cor-transicao]="getCorAvanco()"
              (click)="onAvancarEstadoClick($event)">
      </button>
      <button pButton
              type="button"
              *ngIf="temBotaoFaturar()"
              icon="pi pi-dollar"
              [pTooltip]="texts?.botoes?.faturar || 'Faturar'"
              [attr.aria-label]="texts?.botoes?.faturar || 'Faturar'"
              tooltipPosition="top"
              class="p-button-rounded p-button-icon-only botao-faturar"
              (click)="onFaturarClick($event)">
      </button>
      <!-- Icone = ESTADO_PEDIDO_CONFIG[ENTREGUE].icone (EstadoDePedido.enum.ts:30).
           Fixo no template como os irmaos finalizar/cancelar: o destino nao varia.
           Se o icone do estado ENTREGUE mudar la, mudar aqui tambem. -->
      <button pButton
              type="button"
              *ngIf="temBotaoEntregar()"
              icon="pi pi-check-square"
              [pTooltip]="texts?.botoes?.entregar || 'Entregar'"
              [attr.aria-label]="texts?.botoes?.entregar || 'Entregar'"
              tooltipPosition="top"
              class="p-button-outlined p-button-rounded p-button-icon-only botao-entregar"
              (click)="onEntregarClick($event)">
      </button>
      <button pButton
              type="button"
              *ngIf="temBotaoFinalizar()"
              icon="pi pi-check-circle"
              [pTooltip]="texts?.botoes?.finalizar || 'Finalizar'"
              [attr.aria-label]="texts?.botoes?.finalizar || 'Finalizar'"
              tooltipPosition="top"
              class="p-button-outlined p-button-success p-button-rounded p-button-icon-only botao-finalizar"
              (click)="onFinalizarClick($event)">
      </button>
      <button pButton
              type="button"
              *ngIf="temBotaoCancelar()"
              icon="pi pi-times-circle"
              [pTooltip]="texts?.botoes?.cancelar_pedido || texts?.botoes?.cancelar"
              [attr.aria-label]="texts?.botoes?.cancelar_pedido || texts?.botoes?.cancelar"
              tooltipPosition="top"
              class="p-button-outlined p-button-danger p-button-rounded p-button-icon-only botao-cancelar"
              (click)="onCancelarClick($event)">
      </button>

      <!-- Abre o seletor de estados sem carregar o detalhe (ver `temAtalhoEstados`) -->
      <button pButton
              type="button"
              *ngIf="temAtalhoEstados()"
              icon="pi pi-arrow-right-arrow-left"
              [pTooltip]="texts?.botoes?.estados"
              [attr.aria-label]="texts?.botoes?.estados"
              tooltipPosition="top"
              class="p-button-outlined p-button-rounded p-button-icon-only botao-estados"
              (click)="onAbrirEstadosClick($event)">
      </button>
    </div>
    <!-- Linha de botoes de comunicacao -->
    <div class="footer-comunicacao-row">
      <button pButton
              type="button"
              [label]="texts?.botoes?.whatsapp"
              icon="pi pi-whatsapp"
              class="p-button-outlined p-button-success p-button-sm"
              (click)="onWhatsAppClick($event)"
              *ngIf="pedido.telefone">
      </button>
      <button pButton
              type="button"
              [label]="texts?.botoes?.compartilhar"
              icon="pi pi-share-alt"
              class="p-button-outlined p-button-sm"
              (click)="onCompartilharClick($event)">
      </button>
    </div>
  </div>
</div>
